import { CouriersPrintMapper } from './print';

export class CouriersMapper {
  public static Print = CouriersPrintMapper;
}
